import React from "react";
import {
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { Delete } from "@material-ui/icons";

export default function Content({ data, setCheck, check }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">
          ¿Seguro que quieres eliminar la evaluación?{" "}
          <strong>Esta acción no puede deshacerse.</strong>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">
          Punto GIRA: {data.greenPointID?.name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">
          Monitor GIRA: {data.userId?.name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">
          Registrado por: {data.adminId?.name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2">
          Fecha de creación:{" "}
          {new Intl.DateTimeFormat("es-Es", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          }).format(new Date(data.updatedAt))}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={check}
              onChange={(e) => setCheck(e.target.checked)}
              color="primary"
            />
          }
          label="Confirmo que deseo eliminar esta evaluación"
        />
      </Grid>
    </Grid>
  );
}

Content.propTypes = {
  data: PropTypes.object.isRequired,
  setCheck: PropTypes.func.isRequired,
  check: PropTypes.bool.isRequired,
};
